import { Skeleton } from '@/common-utils/components/ui/skeleton';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@/common-utils/components/ui/table';
import { cn } from '@/common-utils/libraries/tailwind/utils';

/**
 * @param {Object} props
 * @param {number} props.columns
 * @param {number} props.rows
 * @param {string} props.className
 * @returns {JSX} DataTableBodySkeleton
 */
function DataTableBodySkeleton({ columns = 5, rows = 10, className = '' }) {
    return (
        <>
            {Array.from({ length: rows }).map((row, rowIdx) => (
                <TableRow key={`${row}-${rowIdx}`} data-cy='table-skeleton-row'>
                    {Array.from({ length: columns }).map((col, colIdx) => (
                        <TableCell key={`${col}-${colIdx}`}>
                            <Skeleton className={cn('bg-gray-200 h-4 min-w-6 w-full', className)} />
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    );
}

DataTableBodySkeleton.propTypes = {
    columns: PropTypes.number,
    rows: PropTypes.number,
    className: PropTypes.string
};
export default DataTableBodySkeleton;
